import { useEffect, useState } from 'react'
import { V1MultiChannelWidget } from '../generated/widget'

export function useWidgetConfig({ widgetId, region }: { widgetId?: string; region: string }) {
  const retries = 3
  const [data, setData] = useState<V1MultiChannelWidget>()
  const [retryCount, setRetryCount] = useState(0)

  // see https://vite.dev/guide/env-and-mode.html#node-env-and-modes
  const env = import.meta.env.MODE === 'staging' || import.meta.env.DEV ? 'stg' : 'prd'
  const envString = env === 'prd' ? '' : `.${env}`
  const url = `https://api.${region}${envString}.saas.sinch.com/conversation-starters/widget-api/widgets/v1/${widgetId}`

  const error = !widgetId || !region || retryCount >= retries - 1

  // load widget config
  useEffect(() => {
    if (error || !!data) {
      return
    }

    let to: ReturnType<typeof setTimeout> | undefined

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(String(response.statusText || response.status))
        }
        return response.json()
      })
      .then(setData)
      .catch(err => {
        if (retryCount === retries) {
          console.error(`Error ${err?.message || 'Unknown error'}`)
        }
        to = setTimeout(
          () => {
            setRetryCount(r => r + 1)
          },
          (retryCount + 1) * 1000,
        )
      })

    return () => clearTimeout(to)
  }, [data, url, error, retryCount])

  return { data, isError: error }
}
